import styled from 'styled-components';
import { COLORS, DEVICES, pickThemeFontStyles } from '@/theme';
import { Form } from '@/components';
import { QuestionIcon } from '@/icons';

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  height: 100%;
`;

export const StyledForm = styled(Form)`
  justify-content: space-between;
  height: 100%;
`;

export const RegionFieldLabel = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
`;

export const RegionHintIcon = styled(QuestionIcon)`
  width: 1rem;
  height: 1rem;
  cursor: pointer;
`;

export const StyledTitle = styled.div`
  ${pickThemeFontStyles('18', '24', 'BOLD')};
  display: flex;
  color: ${COLORS.DARK_ONYX} !important;
  align-items: center;
  gap: 1rem;

  @media screen and ${DEVICES.LAPTOP_S} {
    ${pickThemeFontStyles('24', '30', 'BOLD')};
  }
`;
